import { render } from "./PerformanceMenagement.vue?vue&type=template&id=0d9f7830&scoped=true&lang=html"
import script from "./PerformanceMenagement.vue?vue&type=script&lang=js"
export * from "./PerformanceMenagement.vue?vue&type=script&lang=js"

import "./PerformanceMenagement.vue?vue&type=style&index=0&id=0d9f7830&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-0d9f7830"

export default script